import React from 'react';
import Prenotazione from '../admin/prenotazione';

/**
 * Il dettaglio di una prenotazione fuori dall'area di amministrazione.
 *
 * La scheda e' la stessa e si adatta da se' a chi la guarda; qui serve solo
 * il guscio della pagina, che dentro l'area admin lo mette il suo indice.
 */
export default function DettaglioPrenotazione() {
    return (
        <main className="lv-shell lv-stack">
            <Prenotazione />
        </main>
    );
}
